import { Box, Grid, Typography } from "@material-ui/core";
import React from "react";
import apiHelper from "../../../../util/ApiHelper";
import AwardCategoryForm from "./AwardCategoryForm";
import AwardCategoryTable from "./AwardCategoryTable";

export default function AwardCategoryListingPage(props) {
  const { match } = props;
  React.useEffect(() => {
    apiHelper.hkiff.getAwardCategory().then((response) => {
      console.log(response.data);
    });
  }, []);

  return (
    <>
      <Box width="100%">
        <Typography variant="h4" gutterBottom>
          Awards & Juries &gt; Award Category
        </Typography>
      </Box>
      <Grid container spacing={4}>
        <Grid item xs={4}>
          <AwardCategoryForm
            formTitle="Add New Award Category"
            buttonText="Create"
          />
        </Grid>
        <Grid item xs={8}>
          <AwardCategoryTable match={match} />
        </Grid>
      </Grid>
    </>
  );
}
